/**
 * @name vegas counting and arranging elements
 * @copyright by vegas s.
 * @date: 09.04.2020
 */

(function ($) {
	
	$.fn.vegasCountElement = function (options) {

		options = $.extend({

		}, arguments[0] || {});

		let container = this;
		let rows = options.rows || 3;
		let margin = options.margin || 5;

		let $elements = $(container).children(),
			$arr_elements = [],
			$arr_elements_show = [],
			$arr_elements_hide = [];

		$elements.each(function () {
			$arr_elements.push({
				self: $(this),
				width: $(this).outerWidth() + margin
			});
		});

		let container_width = $(container).width() * rows, sum = 0;

		for (let i = 0; $arr_elements.length > i; i++) {
			sum += $arr_elements[i].width;

			if (sum < container_width) {
				$arr_elements_show.push($arr_elements[i]);
			} else {
				$arr_elements_hide.push($arr_elements[i]);
			}
		}

		$elements.remove();

		show($arr_elements_show);

		if ($elements.length > $arr_elements_show.length) {
			$(container).parent().append('<a href="#" data-toggle="all-elements" class="mt-2 toggle">Показать еще</a>');
			
			$('[data-toggle=all-elements]').click(function () {
				if($(container).hasClass('show')) {
					$(container).removeClass('show');
					$(this).text('Показать еще');
					hide();
				} else {
					$(container).addClass('show');
					$(this).text('Скрыть');
					show($arr_elements_hide);
				}
				
				return false;
			});
		}

		function show(elements) {
			for (let i = 0; elements.length > i; i++) {
				$(container).append(elements[i].self);
			}
		}

		function hide() {
			for (let i = 0; $arr_elements_hide.length > i; i++) {
				$(container).find($arr_elements_hide[i].self).remove();
			}
		}

		return this;
	};
})(jQuery);